import { render } from "./NewProgressionModal.vue?vue&type=template&id=77a4e24d"
import script from "./NewProgressionModal.vue?vue&type=script&lang=js"
export * from "./NewProgressionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__